
export enum PREPOCET_TYP {
	POPIS_SJ,
	POMER_SJ,
	CHARAKTER_SJ,
}
